import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { SubjectPropType } from '../../../abilities/proptypes';
import SendMailButton from './SendMailButton';
import { NURSE_REQUEST_CANCELATION_ENTITY } from '../../../mailTemplates/entities';
import { PrefillMailPropType } from '../../../mails/proptypes';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { NurseRequestDataPropType } from '../../../../proptypes/careneeds';
import { useNurseRequestCancelationSend } from '../../../nurseRequests/hooks';

const SendNurseRequestCancelationButton = ({
    name,
    disabled,
    nurseRequestData,
    onSent,
    subject,
    action,
    className,
    variant,
    size,
    label,
    fullWidth,
    prefill,
    color,
    ellipsis,
}) => {
    const customerId = nurseRequestData?.customer.id;
    const careNeedId = nurseRequestData?.id;

    const { prepareExtraEntities, handleSent: handleCancelationSent } =
        useNurseRequestCancelationSend(customerId, careNeedId, nurseRequestData?.nurseRequests);

    const extraFields = null; //useMemo(() => null);

    const handleSent = useCallback(
        async (args) => {
            const results = await handleCancelationSent(args);

            if (onSent) {
                await onSent(results);
            }
            return true;
        },
        [handleCancelationSent, onSent]
    );

    return (
        <SendMailButton
            name={name}
            color={color}
            variant={variant}
            startIcon={<DeleteForeverIcon />}
            disabled={disabled}
            action={action}
            subject={subject}
            entity={NURSE_REQUEST_CANCELATION_ENTITY}
            entityId={customerId}
            onSent={handleSent}
            extraEntities={prepareExtraEntities}
            extraFields={extraFields}
            className={className}
            size={size}
            label={label || 'Alle BK-Anfragen absagen'}
            fullWidth={fullWidth}
            prefill={prefill}
            ellipsis={ellipsis}
        />
    );
};

SendNurseRequestCancelationButton.propTypes = {
    name: PropTypes.string,
    onSent: PropTypes.func,
    disabled: PropTypes.bool,
    subject: SubjectPropType,
    action: PropTypes.string,
    variant: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.node,
    fullWidth: PropTypes.bool,
    prefill: PrefillMailPropType,
    ellipsis: PropTypes.bool,
    confirmLabel: PropTypes.string,
    onClick: PropTypes.func,
    nurseRequestData: NurseRequestDataPropType.isRequired,
};

SendNurseRequestCancelationButton.defaultProps = {
    name: null,
    onSent: null,
    disabled: false,
    subject: null,
    action: null,
    variant: undefined,
    color: undefined,
    size: undefined,
    className: null,
    label: null,
    fullWidth: false,
    prefill: null,
    ellipsis: false,
    confirmLabel: null,
    nurseRequestData: null,
};

export default SendNurseRequestCancelationButton;
